import React, { useEffect, useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'rsuite'
import Modal from '../modal/Modal'
import { useAuth } from '../../../contexts/AuthContext'
import './AccountInactiveModal.scss'

const DEFAULT_MESSAGE =
  'Your account has been deactivated. Please contact support.'

const AccountInactiveModal: React.FC = () => {
  const { logout } = useAuth()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState(DEFAULT_MESSAGE)

  useEffect(() => {
    const handleAccountInactive = (event: Event) => {
      const { detail } = event as CustomEvent<{ message?: string }>
      setMessage(detail?.message ?? DEFAULT_MESSAGE)
      setOpen(true)
    }

    window.addEventListener('account-inactive', handleAccountInactive)
    return () => {
      window.removeEventListener('account-inactive', handleAccountInactive)
    }
  }, [])

  const handleLogout = useCallback(() => {
    logout(true)
    setOpen(false)
    navigate('/login', { replace: true })
  }, [logout, navigate])

  return (
    <Modal
      open={open}
      size="xs"
      backdrop="static"
      keyboard={false}
      dialogClassName="account-inactive-modal"
      body={
        <div className="account-inactive-modal__body">
          <div className="account-inactive-modal__icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="13" />
              <line x1="12" y1="16.5" x2="12" y2="16.5" />
            </svg>
          </div>
          <h3 className="account-inactive-modal__title">Account Deactivated</h3>
          <p className="account-inactive-modal__description">{message}</p>
        </div>
      }
      footer={
        <div className="account-inactive-modal__footer">
          <Button
            appearance="primary"
            className="account-inactive-modal__btn"
            onClick={handleLogout}
          >
            Logout
          </Button>
        </div>
      }
    />
  )
}

export default AccountInactiveModal
